import { GridCellParams, GridValidRowModel } from '@mui/x-data-grid-pro'
import cn from 'classnames'
import React, { ComponentProps } from 'react'

import styles from './DataGridCellWrapper.style'

type DataGridCellWrapperProps<Row extends GridValidRowModel> = {
  disabled?: boolean
  compact?: boolean
  params: GridCellParams<Row>
} & ComponentProps<'div'>

const DataGridCellWrapper = <Row extends GridValidRowModel>(
  props: DataGridCellWrapperProps<Row>,
) => {
  const { children, disabled, compact, className, ...rest } = props
  const alignRight = props.params.colDef.align === 'right'

  return (
    <div
      {...rest}
      css={styles}
      className={cn(className, { disabled, alignRight, compact })}
      data-testid={`${props.params.field}-${props.params.row.id}`}
    >
      {children}
    </div>
  )
}

export default DataGridCellWrapper
